<template>
  <div class="container">
    <!--添加工作室成员概况模块-->
    <studioOverview> </studioOverview>
    <membersDataTable> </membersDataTable>
    <productDataTable> </productDataTable>
  </div>
</template>
<script>
import studioOverview from './studioOverview.vue';
import membersDataTable from './membersDataTable.vue';
import productDataTable from './productDataTable.vue';
export default {
  components: {
    studioOverview,
    membersDataTable,
    productDataTable,
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      //数据明细页曝光埋点
      this.$log('studiostudio_data_overview_show', 85442, { v7: 1 });
    },
  },
};
</script>
<style
  src="../../../../assets/styles/introduce-common.scss"
  lang="scss"
  scoped
></style>
<style lang="scss" scoped>
.container {
  .data-table {
    margin-top: 28px;
    border: 1px solid #d9d9d9;
    overflow: hidden;
    border-radius: 3px;
    ::v-deep .el-table tr:last-child td {
      border-bottom: none;
    }
    ::v-deep .el-table::before {
      background: transparent;
    }
    ::v-deep .el-table th {
      background: #fafafa;
      line-height: 29px;
    }
    ::v-deep .el-table td {
      line-height: 29px;
      padding: 7px 0 6px;
    }
  }
  ::v-deep .el-button--text {
    color: #2b6ddf;
  }
  ::v-deep .el-date-editor.el-input__inner {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  ::v-deep .el-range-editor.el-input__inner {
    padding: 3px 0;
  }
  ::v-deep .el-date-editor .el-range__icon {
    display: none;
  }
  ::v-deep .el-date-editor .el-range-separator {
    width: 30px;
    color: #bfbfbf;
  }
  .search_btn {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left: 0;
    color: #595959;
  }
  .download-wrap {
    float: right;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 600;
    margin-top: 18px;
    display: flex;
    align-items: center;
    cursor: pointer;
    color: #2b6ddf;
    img {
      margin-right: 8px;
    }
  }
  .all-look {
    color: #2b6ddf;
    text-decoration: underline;
    display: flex;
    justify-content: center;
  }
}
</style>
